import { useCallback } from 'react';

import Formsy from 'formsy-react';
import { Layers2 } from 'lucide-react';
import { DefaultTooltip, Label, FormGroup, Button, Row, Col } from 'twyne-new.ui';

import { useAppAlert } from '@/components/AppAlert';
import ConfirmationPopover from '@/components/ConfirmationPopover';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';
import Select from '@Components/form/Select';

export default function MoveEntity({ info, asLabel }) {
  const { definitions: { entityName, contentTypeOptions }, events: { handleMoveEntry } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const { row } = getInfo(info)
  const { id, title } = row

  const handleSubmit = useCallback(async model => {
    await handleMoveEntry({ ...row, ...model })
    handleSuccess(`${entityName} moved!`)
  }, [row, handleMoveEntry, handleSuccess, entityName])

  const target = asLabel ? <span>Move</span> : <DefaultTooltip content='Move'><Layers2 size={16} /></DefaultTooltip>

  return <>
    <ConfirmationPopover key={id} id={id} title={<span>Move {entityName.toLowerCase()} <i>{`[#${id}] ${title}`}</i></span>}
      target={target}>
      <Formsy onValidSubmit={handleSubmit}>
        <Row>
          <Col>
            <FormGroup>
              <Label>Move to</Label>
              <Select
                required
                name="content_type"
                options={contentTypeOptions}
                clearable={false}
              />
            </FormGroup>
          </Col>
          <Col>
            <div className='font-bold mb-2'>Are you sure you want move this entry?</div>
            <Button color="accent" type="submit" block>Yes, I am sure</Button>
          </Col>
        </Row>
      </Formsy>
    </ConfirmationPopover>
  </>
}
